/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function () {
  // 1. Theme's hidden cart drawer opens on add-to-cart and locks scroll.
  //    Close it immediately so it dispatches theme:scroll:unlock.
  document.addEventListener('theme:cart-drawer:open', () => {
    setTimeout(() => {
      const drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.closeCartDrawer === 'function') drawer.closeCartDrawer();
    }, 50); // theme applies the lock on a setTimeout, so wait one tick
  });

  // 2. Safety net for bfcache back-navigation.
  window.addEventListener('pageshow', (e) => {
    if (e.persisted) document.dispatchEvent(new CustomEvent('theme:scroll:unlock'));
  });
})();

// Redirect from cart page to card drawer
(function () {
  try {
    if (sessionStorage.getItem('breezy:openCart') !== '1') return;
    sessionStorage.removeItem('breezy:openCart');
  } catch (e) { return; }

  var tries = 0;
  (function open() {
    if (typeof window.upcartOpenCart === 'function') return window.upcartOpenCart();
    if (++tries < 50) setTimeout(open, 100); // wait up to ~5s for UpCart to load
  })();
})();